import * as React from 'react'

type ContextType = { extraFilters?: React.ReactNode; onReset: () => void }
const FilterContext = React.createContext<ContextType>({} as ContextType)

export { FilterContext }
